class CustomDialog extends HTMLElement {
  constructor() {

    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
  }

  connectedCallback() {

    this.dialog = this.querySelector('dialog');
    const dataTargetValue = this.getAttribute('data-target');
    this.buttons = document.querySelectorAll(`button[data-target="${dataTargetValue}"]`);
    this.closeButton = this.querySelectorAll(`button[data-dialog="close"]`);

    if (!this.dialog) {
      console.error(`'${dataTargetValue}: Button or Dialog not found in DOM.'`);
      return
    }

    this.buttons.forEach(button => {
      button.addEventListener('click', this.handleButtonClick);
    });

    this.closeButton.forEach(button => {
      button.addEventListener('click',() => {
        if (this.dialog.querySelector('.dialog')) {
          this.dialog.querySelector('.dialog')?.classList.add('fade-in');
        } else {
          this.dialog.classList.remove('fade-in');
        }
        this.dialog.close();
      });
    });

    this.dialog.addEventListener('click', this.handleDialogClose);

  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleButtonClick);
    }
    if (this.dialog) {
      this.dialog.removeEventListener('close', this.handleDialogClose);
    }
  }

  handleButtonClick() {
    if (!this.dialog) return

    const dialogToFadeIn = this.dialog.querySelector('.dialog') || this.dialog
    dialogToFadeIn.classList.add('fade-in');
    this.dialog.showModal();

  }

  handleDialogClose(event) {
    publish(PUB_SUB_EVENTS.popupClose)
    if (!this.dialog) return
    const rect = this.dialog.getBoundingClientRect();
    const isInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (isInDialog) return
    setTimeout(() =>{
        this.dialog.close();
    }, 400);

    if (this.dialog.querySelector('.dialog')) {
      this.dialog.querySelector('.dialog')?.classList.add('fade-in');
    } else {
      this.dialog.classList.remove('fade-in');
    }
  }

}
customElements.define('custom-dialog', CustomDialog);

class NewsletterDialog extends CustomDialog {
  constructor() {
    super();
    this.subscribeHash = "#ContactFooter";
  }

  connectedCallback() {
    super.connectedCallback();
    this.checkForceOpenPop();
  }

  checkForceOpenPop(){
    const currentUrl = window.location.href;
    if (!currentUrl.includes(this.subscribeHash)) return
    this.handleButtonClick();
    history.replaceState(null, '', currentUrl.replace(this.subscribeHash,''));
  }
}

customElements.define('newsletter-dialog', NewsletterDialog);


class CountryDialog extends CustomDialog {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    subscribe(PUB_SUB_EVENTS.countryPopupOpen, () => {
      this.handleButtonClick();
    })
  }


}

customElements.define('country-dialog', CountryDialog);


class ReturnDialog extends CustomDialog {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.setListeners();
  }

  setListeners() {
    this.querySelector('form').addEventListener('change', () => {
      const items = this.getItems();
      const submitBtn = this.querySelector('button[type="submit"]');
      !items.length ? submitBtn.setAttribute('disabled', 'true') : submitBtn.removeAttribute('disabled')
    })
    this.querySelector('form').addEventListener('submit', (event) => {
      event.preventDefault();
      const errorContainer = this.querySelector('[data-error-container]');
      errorContainer.toggleAttribute('hidden', true);
      this.handleReturn();
    });
  }

  getItems() {
    const formData = new FormData(this.querySelector('form'));
    return Object.values(Object.fromEntries(formData.entries())).map(value => JSON.parse(value));

  }

  handleReturn() {
    const items = this.getItems();

    const orderId = parseInt(this.querySelector('input[name="entity_id"]').value);
    const orderName = this.querySelector('input[name="increment_id"]').value;
    const customerId = parseInt(this.querySelector('input[name="customer_id"]').value);
    const customerEmail = this.querySelector('input[name="customer_email"]').value;

    const currentDate = new Date();
    const currentTimezone = currentDate.getTimezoneOffset() / 60 * -1;
    currentDate.setHours(currentDate.getHours() + currentTimezone);
    const createdAt = currentDate.toISOString().split('.')[0] + "+0" + currentTimezone + ":00";

    const body = {
      "entity_id": orderId,
      "increment_id": orderName,
      "customer_id": customerId,
      "customer_email": customerEmail,
      "created_at": createdAt,
      "line_items": items
    };

    this.makeRequests(body);
  }

  async makeRequests(body) {
    try {
      const token = await this.getToken();
      await this.addReturnOrder(token, body);

      const successContainer = this.querySelector('[data-success-container]');
      successContainer.toggleAttribute('hidden', false);

    } catch (error) {
      this.errorHandler(error);
    }
  }

  errorHandler(error) {
    const errorContainer = this.querySelector('[data-error-container]');
    errorContainer.toggleAttribute('hidden', false);
    const errorMessage = error.Message;

    errorContainer.querySelector('[data-error-message]').textContent = errorMessage;
  }

  async getToken() {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    const body = JSON.stringify({
      "Username": "evocon",
      "Password": "Evocon123!"
    });

    const options = {
      method: 'POST',
      headers: headers,
      body: body,
    };

    const response = await fetch("https://4snext-stb.sys-web.it/SysDat.Stark.WebApi/api/account/token", options);
    const responseJson = await response.json();

    const token = responseJson.token;
    if (!token)
      throw {Message: 'missing-token'};

    return token;
  }

  async addReturnOrder(token, body) {
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + token);
    headers.append("Company-Key", "STBARTH");
    headers.append("Content-Type", "application/json");

    const options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    };

    const response = await fetch("https://4snext-stb.sys-web.it/SysDat.Stark.WebApi/api/EcommerceReturnOrderHeader/add-return-order", options)
    const result = await response.json();

    if (!response.ok)
      throw result[0];

    return result;
  }


}

customElements.define('return-dialog', ReturnDialog);
